import React from 'react'
import { FormattedNumber as IntlFormattedNumber } from 'react-intl'
import { Box } from '@mui/material'

export default function FormattedNumber({ value, decimals = 2, percent = false, align = 'right' }) {
  const numericValue = parseFloat(value)
  if (isNaN(numericValue)) return <>–</>

  return (
    <Box component="span" sx={{ display: 'inline-block', textAlign: align, width: '100%' }}>
      {percent ? (
        <IntlFormattedNumber
          value={numericValue / 100}
          style="percent"
          minimumFractionDigits={decimals}
          maximumFractionDigits={decimals}
        />
      ) : (
        <IntlFormattedNumber
          value={numericValue}
          minimumFractionDigits={decimals}
          maximumFractionDigits={decimals}
        />
      )}
    </Box>
  )
}
